import React from "react"
import TrendingCard from "./card/TrendingCard"

export default function Trending({ data }) {
  return (
    <section>
      <div>
        <h3 className="text-xl md:text-3xl font-bold text-center pt-6">
          Trending Locations
        </h3>
      </div>
      <div className="grid w-11/12 mx-auto gap-4 md:gap-0 md:w-full md:grid-cols-2 lg:grid-cols-3 py-12 md:py-20">
        {data.map((d, key) => {
          return (
            <TrendingCard
              slug={`/trending/${d.node.slug.current}`}
              image={d.node.cover.asset.gatsbyImageData}
              title={d.node.name}
              key={key}
            />
          )
        })}
      </div>
    </section>
  )
}
